/** 与主 utils 包解耦，避免 `utils/index` ↔ `useNavigation` 循环依赖 */
export function jumpTo(jumpPath: string) {
  const path = jumpPath.startsWith('/') ? jumpPath : `/${jumpPath}`;
  if (!window.location.pathname.startsWith(path)) {
    window.location.replace(path);
  }
}
